import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Template } from './common';
import { GlobalStyle } from './assets/GlobalStyle/GlobalStyle';
import { AuthContext } from './helpers/context_manager/AuthContext';
import { ReferencesProvider } from './helpers/context_manager/ReferencesProvider';

export const App: React.FC = () => {
  const [authToken, setAuthToken] = useState<string | null>(localStorage.getItem('authToken'));

  return (
    <AuthContext.Provider value={{ authToken, setAuthToken }}>
      <ReferencesProvider>
        <BrowserRouter>
          <GlobalStyle />
          <Template />
        </BrowserRouter>
      </ReferencesProvider>
    </AuthContext.Provider>
  );
};
